import allSelectorDefinition from './all.js'
import allForNetworkSelectorDefinition from './all-for-network.js'
import allWithParentCombinedNetworkSelectorDefinition from './all-with-parent-combined-network.js'
import allWithoutParentCombinedNetworkSelectorDefinition from './all-without-parent-combined-network.js'
import createCombinedChildrenNamesSelectorDefinition from './create-combined-children-names.js'
import getCombinedFallbackSelectorDefinition from './get-combined-fallback.js'
import getHasAssetsOnOtherChainsSelectorDefinition from './get-has-assets-on-other-chains.js'
import getSelectorDefinition from './get.js'
import getParentCombinedSelector from './get-parent-combined.js'
import getIsBaseAssetWithChainIconSelector from './get-is-base-asset-with-chain-icon.js'
import getIsAssetWithNetworkIconSelector from './get-is-asset-with-network-icon.js'

export default [
  //
  allSelectorDefinition,
  allForNetworkSelectorDefinition,
  allWithParentCombinedNetworkSelectorDefinition,
  allWithoutParentCombinedNetworkSelectorDefinition,
  createCombinedChildrenNamesSelectorDefinition,
  getCombinedFallbackSelectorDefinition,
  getHasAssetsOnOtherChainsSelectorDefinition,
  getSelectorDefinition,
  getParentCombinedSelector,
  getIsBaseAssetWithChainIconSelector,
  getIsAssetWithNetworkIconSelector,
]
